import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import EnquiryForm from "./EnquiryForm";

export default function EnquiryModal({ open, onClose, intent, title }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[80] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            data-testid="enquiry-modal"
            className="relative bg-white border border-border w-full max-w-lg p-8 md:p-10 max-h-[90vh] overflow-y-auto shadow-[0_30px_90px_rgba(18,32,49,0.3)]"
            initial={{ y: 60, opacity: 0, scale: 0.96 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 40, opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          >
            <button
              onClick={onClose}
              data-testid="enquiry-modal-close"
              className="absolute top-4 right-4 p-2 text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Close"
            >
              <X size={18} />
            </button>
            <p className="text-[10px] uppercase tracking-[0.35em] text-primary mb-2 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse" />
              Limited Pre-Launch Benefits
            </p>
            <p className="font-display text-2xl md:text-3xl mb-8">{title || "Pre-register for best benefits"}</p>
            <EnquiryForm defaultIntent={intent} onSuccess={onClose} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
